import { AnalysisType } from "../measuring-point";
import { IMeasuringPointStatusCreator } from "../measuring-point-status";
import { IProjectNavigator } from "../project";
import { IVehicleAnalysisTypeConfiguration } from "../vehicle-analysis-type-configuration";

export interface IMeasuringPointStatusSummary {
    measuringPointId: number;
    analysisType: AnalysisType;
    code: string;
    description: string;
    from: string;
    to: string;
    heading?: number;
    lastDeviceLinkValidFrom?: Date;
    lastDeviceLinkValidUntil?: Date;
    isDeviceLinkActive: boolean;
    currentStatus: IMeasuringPointStatusCreator;
    projects: IProjectNavigator[];
    mapIconStateId: number;

    vehicleConfiguration: IVehicleAnalysisTypeConfiguration;
}
